import React from 'react';
import BulmaHeading from 'react-bulma-components/lib/components/heading';

export const Heading = ({ children, size, subtitle = false, ...props }) => (
  <BulmaHeading size={size} subtitle={subtitle} {...props}>
    {children}
  </BulmaHeading>
);

export default Heading;
